export default "__VITE_ASSET__BbbUiMuE__"